export default __webpack_public_path__ + "static/media/img-festa-virtual.bf6c79f7.png";